/* @flow */

import React from 'react';
import DiffusionList from 'diffusion/components/DiffusionList';

type Props = {
  security: CatalogSecurity,
  onUpdate?: (security: CatalogSecurity) => void,
};

const DiffusionSecurity = ({ security, onUpdate }: Props) => {
  const updateTargets = targets =>
    onUpdate({
      ...security,
      targets,
    });

  return (
    <DiffusionList
      targets={security.targets}
      onUpdate={updateTargets}
      isEditable={true}
    />
  );
};

export default DiffusionSecurity;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/security/diffusion/DiffusionSecurity.js